import { createContext } from 'react';
import { ChannelManager } from '../../entities/channel_manager/model';

export interface IUserCamp {
  full_name: string;
  id: number;
  img: string;
  has_pending_contract: boolean;
  on_sale: boolean;
  apartments_count?: number;
  has_prices?: boolean;
  tariffs_with_apartment_count?: number;
  pictures_count?: number;
  camp_contacts_for_guests?: boolean;
  camp_contacts_for_booking?: boolean;
  service_tags_count?: number;
  settings_filled?: boolean;
  on_moderate?: boolean;
}

export interface USER_CONTEXT {
  current_camp: {
    full_name: string;
    id: number;
    seo_path?: string;
    seo_path_kx?: string;
    seo_path_ubook?: string;
    has_channel_manager: boolean;
    has_pending_contract: boolean;
    channel_manager?: ChannelManager;
    show_planning: boolean;
    send_books_to_extranet: boolean;
    has_camp_site: boolean;
    contract_conclusion_form: string;
  } & IUserCamp;
  setCurrentCamp: (camp: USER_CONTEXT['current_camp']) => void;
  setUserCamps?: (camps: Array<IUserCamp>) => void;
  updateCurrentCamp: (updater: (camp: USER_CONTEXT['current_camp']) => USER_CONTEXT['current_camp']) => void;
  camps: Array<IUserCamp>;
  current_user: {
    name: string;
    is_admin: boolean;
    id: number;
    is_new_extranet_user: boolean;
  };
  sign_in_url?: string;
  disable_camps_with_autocompleted: boolean;
  existing_contractor_present?: boolean;
}

export const DEFAULT_USER_CONTEXT: USER_CONTEXT = {
  current_camp: {
    full_name: '',
    id: 0,
    seo_path: '',
    seo_path_kx: '',
    seo_path_ubook: '',
    has_channel_manager: false,
    has_pending_contract: false,
    show_planning: false,
    send_books_to_extranet: false,
    has_camp_site: false,
  },
  setCurrentCamp: () => {},
  camps: [],
  current_user: { name: '', is_admin: false, id: 0, is_new_extranet_user: true },
  disable_camps_with_autocompleted: false,
  existing_contractor_present: false,
};

export const UserContext = createContext<USER_CONTEXT>(DEFAULT_USER_CONTEXT);
